import {
  Typography,
  Container,
  Grid,
  Box,
  FormControl,
  MenuItem,
  Select,
  FormHelperText,
  CircularProgress,
} from "@mui/material";
import React, { useState } from "react";
import { allColors } from "../../constants";
import { icons, images } from "../../assets";
import { Phone as PhoneIcon } from "@mui/icons-material";
import GlobalButton from "../../components/globalButton/index";
import TextInput from "../../components/textInput/index";
import { callBackRequestDevelopment } from "../../services/callBackApiFn";
import Swal from "sweetalert2";
import { validateDevelopmentServiceForm } from "../../utils/validation";

const SERVICES_OPTIONS = [
  {
    title: "SaaS Software Development",
    value: "saas_software_development",
  },
  {
    title: "Mobile Application Development",
    value: "mobile_application_development",
  },
  {
    title: "UI / UX Design & Prototyping",
    value: "ui_ux_design_and_prototyping",
  },
  {
    title: "Graphic Design",
    value: "graphic_design",
  },
  {
    title: "SEO & Digital markting",
    value: "seo_and_digital_marketing",
  },
  {
    title: "Full Stack Development",
    value: "full_stack_development",
  },
];

const INITIAL_INPUT_VALUES = {
  name: "",
  email: "",
  phone: "",
  service: "",
  message: "",
};

const ContactForm = ({ openChatBoxRef }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [inputErrors, setInputErrors] = useState({});
  const [inputValues, setInputValues] = useState(INITIAL_INPUT_VALUES);

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setInputValues({ ...inputValues, [name]: value });
    setInputErrors({ ...inputErrors, [name]: "" });
  };

  const handleSendCallBackRequest = async () => {
    if (validateDevelopmentServiceForm(inputValues, setInputErrors)) {
      return;
    }

    try {
      setIsLoading(true);
      const response = await callBackRequestDevelopment(inputValues);
      if (response.data.status === "success") {
        Swal.fire({
          title: "Success!",
          text: "Your callback request has been sent successfully.",
          icon: "success",
          confirmButtonColor: "#0073e6",
          confirmButtonText: "OK",
        });
        setInputValues(INITIAL_INPUT_VALUES);
      } else {
        Swal.fire({
          title: "Failed!",
          text: "Something went wrong. Please try again.",
          icon: "error",
          confirmButtonColor: "#d33",
          confirmButtonText: "OK",
        });
      }
    } catch (error) {
      Swal.fire({
        title: "Error!",
        text: error?.message || "An unexpected error occurred.",
        icon: "error",
        confirmButtonColor: "#d33",
        confirmButtonText: "OK",
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Container
      sx={{
        maxWidth: "1250px !important",
      }}
      id="development-service-contact-us"
    >
      <Typography
        sx={{
          textAlign: "center",
          fontSize: { xs: "30px", sm: "40px", md: "50px" },
          color: allColors.jetBlack,
          fontWeight: "400",
          fontFamily: "Raleway",
        }}
      >
        Trust. Connect.
      </Typography>
      <Typography
        sx={{
          textAlign: "center",
          fontSize: { xs: "14px", md: "20px" },
          color: allColors.jetBlack,
          fontWeight: "400",
          margin: "15px 0 30px",
          fontFamily: "Raleway",
        }}
      >
        Have a question or ready to switch? Our experts are here to help
      </Typography>

      <Grid container spacing={3.5} justifyContent={"center"}>
        <Grid item xs={12} sm={6} md={4.5}>
          <Box
            sx={{
              border: `1px solid ${allColors.lightSilver}`,
              borderRadius: "20px",
              padding: { xs: "28px 20px", sm: "70px 20px" },
              textAlign: "center",
            }}
          >
            <a
              href="tel:02076292222"
              style={{ margin: "8px 0", textDecoration: "none" }}
            >
              <PhoneIcon
                sx={{
                  color: allColors.blueCrayola,
                  height: "50px",
                  width: "50px",
                }}
              />
              <Typography
                sx={{
                  fontSize: { xs: "17px", md: "22px" },
                  color: allColors.jetBlack,
                  fontWeight: "600",
                  marginTop: "6px",
                  fontFamily: "Raleway",
                }}
              >
                Call us
              </Typography>
            </a>

            {/* <Typography
                  sx={{
                    fontSize: { xs: "20px", sm: "25px", md: "33px" },
                    color: allColors.blueCrayola,
                    fontWeight: "400",
                    fontFamily: "Raleway",
                  }}
                >
                  0845 561 2525
                </Typography> */}
            <Typography
              sx={{
                fontSize: "14px",
                color: allColors.philippineGray,
                fontWeight: "400",
                fontFamily: "Raleway",
              }}
            >
              Mon - Fri 9:00am - 6:00pm
            </Typography>
          </Box>
          <Box
            sx={{
              border: `1px solid ${allColors.lightSilver}`,
              borderRadius: "20px",
              padding: { xs: "28px 20px", sm: "60px 20px" },
              textAlign: "center",
              marginTop: "25px",
            }}
          >
            <img
              src={icons.circleChatIcon}
              style={{ width: "50px", height: "50px" }}
            />
            <Typography
              sx={{
                fontSize: { xs: "17px", md: "22px" },
                color: allColors.jetBlack,
                fontWeight: "600",
                marginTop: "6px",
                fontFamily: "Raleway",
              }}
            >
              Chat
            </Typography>
            <Typography
              sx={{
                fontSize: { xs: "16px", md: "18px" },
                color: allColors.blueCrayola,
                fontWeight: "400",
                margin: "8px 0",
                fontFamily: "Raleway",
                cursor: "pointer",
              }}
              onClick={() => {
                openChatBoxRef.current.openDialog();
              }}
            >
              Click to start
            </Typography>
            <Typography
              sx={{
                fontSize: "14px",
                color: allColors.philippineGray,
                fontWeight: "400",
                fontFamily: "Raleway",
              }}
            >
              Mon - Fri 9:00am - 6:00pm
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={12} sm={6} md={4.5}>
          <Box
            sx={{
              border: `1px solid ${allColors.lightSilver}`,
              borderRadius: "20px",
              padding: "20px",
              textAlign: "center",
            }}
          >
            <img
              src={icons.circleTimerIcon}
              style={{ width: "50px", height: "50px" }}
            />
            <Typography
              sx={{
                fontSize: { xs: "17px", md: "22px" },
                color: allColors.jetBlack,
                fontWeight: "600",
                margin: "6px 0 15px",
                fontFamily: "Raleway",
              }}
            >
              Request a callback
            </Typography>

            <TextInput
              fullWidth
              placeholder={"Enter your name"}
              type={"text"}
              name={"name"}
              value={inputValues.name}
              onChange={handleInputChange}
              inputError={!!inputErrors.name}
              helperText={inputErrors.name}
            />
            <Box sx={{ margin: "8px 0" }}>
              <TextInput
                fullWidth
                placeholder={"Enter your email"}
                type={"email"}
                name={"email"}
                value={inputValues.email}
                onChange={handleInputChange}
                inputError={!!inputErrors.email}
                helperText={inputErrors.email}
              />
            </Box>
            <TextInput
              type={"number"}
              fullWidth
              placeholder={"Enter your phone number"}
              name={"phone"}
              value={inputValues.phone}
              onChange={handleInputChange}
              inputError={!!inputErrors.phone}
              helperText={inputErrors.phone}
            />

            <Box sx={{ margin: "8px 0" }}>
              <FormControl
                error={!!inputErrors.service}
                fullWidth
                sx={{
                  "&.MuiFormControl-root .MuiFormLabel-root": {
                    marginLeft: "15px",
                    color: allColors.darkGray,
                    fontSize: "12px",
                  },
                  "& .MuiSelect-outlined": {
                    padding: "13px 16px",
                  },
                  "& .MuiInputBase-root": {
                    borderRadius: "15px",
                    fontSize: "12px",
                    background: "transparent",
                    color: allColors.black,
                  },

                  "& .MuiInputBase-root .MuiOutlinedInput-notchedOutline": {
                    borderColor: `${allColors.silverSand} !important`,
                  },
                }}
              >
                <Select
                  displayEmpty
                  value={inputValues.service}
                  onChange={handleInputChange}
                  sx={{ textAlign: "left", color: "#a6a6a6" }}
                  name="service"
                >
                  <MenuItem value={""}>Select Service</MenuItem>

                  {SERVICES_OPTIONS.map((item, index) => (
                    <MenuItem key={index} value={item.value}>
                      {item.title}
                    </MenuItem>
                  ))}
                </Select>
                {inputErrors.service && (
                  <FormHelperText
                    sx={{
                      color: allColors.red,
                      fontSize: "12px",
                    }}
                  >
                    {inputErrors.service}
                  </FormHelperText>
                )}
              </FormControl>
            </Box>

            <TextInput
              fullWidth
              placeholder={"Enter your message"}
              isMultiline
              minRows={4}
              name={"message"}
              onChange={handleInputChange}
              value={inputValues.message}
              inputError={!!inputErrors.message}
              helperText={inputErrors.message}
            />

            <Box>
              <GlobalButton
                title={"Submit"}
                handleClickBtn={handleSendCallBackRequest}
                startIcon={
                  isLoading ? (
                    <CircularProgress size={16} color="inherit" />
                  ) : null
                }
                disabled={isLoading}
                style={{
                  width: "100%",
                  background: allColors.jasmine,
                  color: allColors.jetBlack,
                  borderRadius: "10px",
                  fontSize: "14px",
                  padding: "6px 30px",
                  marginTop: "15px",
                  fontWeight: "700",
                }}
              />
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Container>
  );
};

export default ContactForm;
